/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigurationFileUrls
 */
export interface ConfigurationFileUrls {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationFileUrls
     */
    initFile: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationFileUrls
     */
    stylingFile: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationFileUrls
     */
    summaryFile: string;
}

export function ConfigurationFileUrlsFromJSON(json: any): ConfigurationFileUrls {
    return ConfigurationFileUrlsFromJSONTyped(json, false);
}

export function ConfigurationFileUrlsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationFileUrls {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'initFile': json['initFile'],
        'stylingFile': json['stylingFile'],
        'summaryFile': json['summaryFile'],
    };
}

export function ConfigurationFileUrlsToJSON(value?: ConfigurationFileUrls | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'initFile': value.initFile,
        'stylingFile': value.stylingFile,
        'summaryFile': value.summaryFile,
    };
}


